export const SESSION_LIST = [
  { value: '2021-2022', label: '2021-2022' },
  { value: '2022-2023', label: '2022-2023' },
  { value: '2023-2024', label: '2023-2024' },
  { value: '2024-2025', label: '2024-2025' },
  { value: '2025-2026', label: '2025-2026' },
]
export const CLASS_LIST = [
  { value: '16', label: 'PRE-NUR' },
  { value: '1', label: 'NUR' },
  { value: '2', label: 'KG I' },
  { value: '3', label: 'KG II' },
  { value: '4', label: 'G1' },
  { value: '5', label: 'G2' },
  { value: '6', label: 'G3' },
  { value: '7', label: 'G4' },
  { value: '8', label: 'G5' },
  { value: '9', label: 'G6' },
  { value: '10', label: 'G7' },
  { value: '11', label: 'G8' },
  { value: '12', label: 'G9' },
  { value: '13', label: 'G10' },
  { value: '14', label: '11' },
  { value: '15', label: '12' },
]
export const SECTION_LIST = [
  { value: 'A', label: 'Section A' },
  { value: 'B', label: 'Section B' },
  { value: 'C', label: 'Section C' },
  { value: 'D', label: 'Section D' },
]
export const FEE_HEADS_LIST = [
  {
    Fee_Head_Id: 1,
    Fee_Head_Name: 'Admission Fee',
  },
  {
    Fee_Head_Id: 2,
    Fee_Head_Name: 'Caution Money',
  },
  {
    Fee_Head_Id: 7,
    Fee_Head_Name: 'School Fee',
  },
  {
    Fee_Head_Id: 8,
    Fee_Head_Name: 'Transport Fee',
  },
  {
    Fee_Head_Id: 14,
    Fee_Head_Name: 'Re Admission Fee',
  },
  {
    Fee_Head_Id: 15,
    Fee_Head_Name: 'Late Fee',
  },
  {
    Fee_Head_Id: 16,
    Fee_Head_Name: 'Previous Year Dues',
  },
  {
    Fee_Head_Id: 17,
    Fee_Head_Name: 'Cheque Bounce Fee',
  },
  {
    Fee_Head_Id: 18,
    Fee_Head_Name: 'Non Adjusted Amount',
  },
]
export const STUDENT_LIST = [
  {
    status: 'Success',
    Student_Id: '24/6073',
    Roll_No: 2,
    Student_Name: '#24/6073 - Aquila Camacho Keefe Koch Hensley',
  },
  {
    status: 'Success',
    Student_Id: '24/6074',
    Roll_No: 2,
    Student_Name: '#24/6074 - ASHIYUG  KUMAR KUMARI',
  },
]
